/**
 * @file Renders an Overview figure that has no answer: a spinner while it
 * loads, otherwise `AnalyticsRefusal` for the refused or failed answer or the
 * refused column. Consumers: the Overview tiles, chart and credit tables. It
 * never renders a number, so an unanswered figure never reads as zero.
 */
import { FC } from 'react';
import { Spin } from 'antd';

import type { AnalyticsUnansweredFigure as UnansweredFigure } from '@/analytics';

import { AnalyticsRefusal } from './AnalyticsRefusal';

export const AnalyticsUnansweredFigure: FC<{ figure: UnansweredFigure }> = ({
  figure,
}) => {
  if (figure.status === 'loading')
    return <Spin size="small" aria-label="Loading analytics" />;
  if (figure.status === 'refused')
    return <AnalyticsRefusal answer={figure.answer} />;
  return <AnalyticsRefusal column={figure.column} />;
};
